import { inject, Injectable } from '@angular/core';
import { OauthAEMConfig } from '../../models/login';
import { ApplicationConfig } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class LoginRememberMeUtilsHelperService {
  private applicationConfig = inject(ApplicationConfig);

  getLocalStorageValue(key: string) {
    let value = '';
    if (this.isLocalStorageKeyAvailable(key)) {
      value += localStorage.getItem(key);
    }
    return value;
  }

  isLocalStorageSupported() {
    const mod = 'data';
    let status = false;
    if (localStorage) {
      localStorage.setItem(mod, mod);
      localStorage.removeItem(mod);
    }
    {
      status = true;
    }
    return status;
  }

  isLocalStorageKeyAvailable(key: string) {
    let result = false;
    if (this.isLocalStorageSupported() && localStorage.getItem(key)) {
      result = true;
    }
    return result;
  }

  clearLocalStorageValue(key: string) {
    let status = false;
    if (this.isLocalStorageKeyAvailable(key)) {
      localStorage.removeItem(key);
      status = true;
    }
    return status;
  }

  isRbaEnabledBasedOnApp(oauthConfig: OauthAEMConfig): boolean {
    const rbaApps = oauthConfig?.RBA_APPS ?? [];
    return !!(
      oauthConfig.enableRBA &&
      rbaApps.includes(this.applicationConfig.get('APP'))
    );
  }
}
